import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  demoVisitors: [],
  pages: 0,
};

const demoVisitorsSlice = createSlice({
  name: "demoVisitors",
  initialState,
  reducers: {
    setDemoVisitors(state, action) {
      state.demoVisitors = action.payload;
    },
    addDemoVisitor(state, action) {
      state.demoVisitors.push(action.payload);
    },
  },
});

export function getDemoVisitors({ page, pageSize }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/demo-visitor`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            page: page,
            pageSize: pageSize,
          },
        }
      );
      dispatch(demoVisitorsSlice.actions.setDemoVisitors(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(demoVisitorsSlice.actions.setDemoVisitors([]));
      return Promise.reject(error.message);
    }
  };
}

export async function storeDemoVisitor({ data }) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/demo-visitor`,
      data,
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_POS2CLOUD_BACKEND_BASIC_HEADER}`,
        },
      }
    );
    return Promise.resolve(response.data.message);
  } catch (error) {
    return Promise.reject(error.message);
  }
}

export default demoVisitorsSlice.reducer;
